module.exports = __webpack_public_path__ + "static/media/icon_customer_location.33abbd12.svg";